"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTimeColorClass = function (timeMinDays) {
    if (timeMinDays < 730) {
        return 'text-good';
    }
    return 'text-neutral';
};
exports.default = getTimeColorClass;
